import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_MaintenancePage = _resolveComponent("MaintenancePage");
    return (_ctx.isGood)
        ? _renderSlot(_ctx.$slots, "default", { key: 0 })
        : (_openBlock(), _createBlock(_component_MaintenancePage, { key: 1 }));
}
